const conversionEvents = Object.freeze({
  hero: 'smartdna:hero_cta_clicked',
  object: 'smartdna:object_selected',
  compare: 'smartdna:product_compare_opened',
});

const approvedEventNames = new Set(Object.values(conversionEvents));
const approvedPayloadKeys = Object.freeze(['route', 'filter', 'product', 'placement']);
const maximumPayloadValueLength = 120;
const controlCharacters = /[\u0000-\u001F\u007F-\u009F]/u;

function analyticsAllowed() {
  try {
    const privacy = window.Shopify?.customerPrivacy;
    return privacy?.analyticsProcessingAllowed?.call(privacy) === true;
  } catch {
    return false;
  }
}

function sanitizePayload(payload) {
  return approvedPayloadKeys.reduce((safe, key) => {
    const value = payload?.[key];
    if (typeof value !== 'string') return safe;

    const sanitized = value.trim();
    if (!sanitized || sanitized.length > maximumPayloadValueLength || controlCharacters.test(sanitized)) return safe;

    safe[key] = sanitized;
    return safe;
  }, {});
}

async function publishConversionEvent(name, payload = {}) {
  if (!approvedEventNames.has(name) || !analyticsAllowed()) return false;

  // Coarse, non-identifying segments. Wholesale status is vendor-owned; an
  // unavailable flag stays unclassified rather than guessing from page or login.
  const device = window.matchMedia('(max-width: 620px)').matches
    ? 'mobile'
    : window.matchMedia('(max-width: 989px)').matches ? 'tablet' : 'desktop';
  const customerType = window.isWsgCustomer === true
    ? 'wholesale'
    : window.isWsgCustomer === false ? 'retail' : 'unclassified';
  const detail = { ...sanitizePayload(payload), device, customer_type: customerType };
  const analytics = window.Shopify?.analytics;

  if (typeof analytics?.publish === 'function') {
    try {
      const result = await analytics.publish(name, detail);
      return result !== false;
    } catch {
      return false;
    }
  }

  try {
    return window.dispatchEvent(new CustomEvent(name, { detail })) !== false;
  } catch {
    return false;
  }
}

document.addEventListener('click', (event) => {
  const trigger = event.target instanceof Element ? event.target.closest('[data-smartdna-event]') : null;
  if (!(trigger instanceof HTMLElement)) return;

  const { smartdnaEvent: name, smartdnaRoute: route, smartdnaFilter: filter, smartdnaProduct: product, smartdnaPlacement: placement } =
    trigger.dataset;

  void publishConversionEvent(name, { route, filter, product, placement });
});

document.addEventListener('toggle', (event) => {
    if (!(event.target instanceof HTMLDetailsElement)) return;

    const comparison = event.target.matches('[data-smartdna-compare]') ? event.target : null;
    if (!(comparison instanceof HTMLDetailsElement)) return;
    if (comparison.open === false) return;

    const { smartdnaRoute: route, smartdnaPlacement: placement } = comparison.dataset;
    void publishConversionEvent(conversionEvents.compare, { route, placement });
  }, true);
